import React from "react";
import Carousel from "react-multi-carousel";
import "./WithScrollbas.css";
import "react-multi-carousel/lib/styles.css";
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

class WithScrollbar extends React.Component {
  state = { additionalTransfrom: 0 };
  render() {
    const CustomSlider = ({ carouselState }) => {
      let value = 0;
      let carouselItemWidth = 0;
      if (this.Carousel) {
        carouselItemWidth = this.Carousel.state.itemWidth;
        const maxTranslateX = Math.round(
          // so that we don't over-slide
          carouselItemWidth *
            (this.Carousel.state.totalItems -
              this.Carousel.state.slidesToShow) +
            150
        );
        value = maxTranslateX / 100; // calculate the unit of transform for the slider
      }
      const { transform } = carouselState;
      const computedValue = Math.round(Math.abs(transform) / value);

      return (
        <div className="custom-slider">
          <input
            type="range"
            value={(computedValue)}
            max={
              (carouselItemWidth *
                (carouselState.totalItems - carouselState.slidesToShow) +
                (this.state.additionalTransfrom === 150 ? 0 : 150)) /
              value
            }
            onChange={e => {
              if (this.Carousel.isAnimationAllowed) {
                this.Carousel.isAnimationAllowed = false;
              }
              const nextTransform = e.target.value * value;
              const nextSlide = Math.round(nextTransform / carouselItemWidth);
              if (
                e.target.value == 0 &&
                this.state.additionalTransfrom === 150
              ) {
                this.Carousel.isAnimationAllowed = true;
                this.setState({ additionalTransfrom: 0 });
              }
              this.Carousel.setState({
                transform: -nextTransform, // padding 20px and 5 items.
                currentSlide: nextSlide
              });
            }}
            className="custom-slider__input"
          />
        </div>
      );
    };
    return (
      <Carousel
        ssr={false}
        ref={el => (this.Carousel = el)}
        partialVisbile={false}
        customLeftArrow={
          <MdKeyboardArrowLeft
            className="position-absolute start-0 ms-2 mb-2 pointer"
            style={{
              border:'1px solid rgba(31, 126, 120, 1)',
              backgroundColor: "rgba(217, 217, 217, 0.5)",
              borderRadius: "50%",
            }}
            size={"40px"}
            color="rgba(31, 126, 120, 1)"
          />
        }
        customRightArrow={
          <MdKeyboardArrowRight
            className="position-absolute end-0 me-4 mb-2 pointer"
            style={{
              border:'1px solid rgba(31, 126, 120, 1)',
              backgroundColor: "rgba(217, 217, 217, 0.5)",
              borderRadius: "50%",
            }}
            size={"40px"}
            color="rgba(31, 126, 120, 1)"
          />
        }
        customButtonGroup={<CustomSlider />}
        itemClass="w-100 h-100 me-2"
        responsive={responsive}
        containerClass="w-100 h-100 "
        additionalTransfrom={-this.state.additionalTransfrom}
        beforeChange={nextSlide => {
          if (nextSlide !== 0 && this.state.additionalTransfrom !== 150) {
            this.setState({ additionalTransfrom: 150 });
          }
          if (nextSlide === 0 && this.state.additionalTransfrom === 150) {
            this.setState({ additionalTransfrom: 0 });
          }
        }}
      >
    {this.props.children}
      </Carousel>
    );
  }
}

export default WithScrollbar;
